import { alpha, IconButtonProps, useTheme } from '@mui/material';
import { forwardRef } from 'react';
import { IconButtonAnimate } from '../animate';

// ----------------------------------------------------------------------

interface MIconButtonProps extends Omit<IconButtonProps, 'color'> {
  color?: 'inherit' | 'default' | 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error';
}

const MIconButton = forwardRef<HTMLButtonElement, MIconButtonProps>(({ color = 'default', children, sx, ...other }, ref) => {
  const theme = useTheme();

  if (color === 'default' || color === 'inherit' || color === 'primary' || color === 'secondary') {
    return (
      <IconButtonAnimate ref={ref} color={color} sx={sx} {...other}>
        {children}
      </IconButtonAnimate>
    );
  }

  return (
    <IconButtonAnimate
      ref={ref}
      sx={{
        color: theme.palette[color].main,
        '&:hover': {
          bgcolor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity),
        },
        ...sx,
      }}
      {...other}>
      {children}
    </IconButtonAnimate>
  );
});

export default MIconButton;
